module.exports = __webpack_public_path__ + "img/3ea428fccc6ed691668be5dcb9ce9021.png";